module.exports = __webpack_public_path__ + "static/img/3_1_2.d2b5f8eb.jpg";